module.exports = __webpack_public_path__ + "static/media/1.c5b1de27.jpg";